var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyboardMouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 35.282",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Keyboard and Mouse") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.205,
    cy: 21.966,
    r: 1.722
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.308,
    y: 15.991,
    width: 2.955,
    height: 2.955
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.308,
    y: 26.334,
    width: 14.776,
    height: 2.955
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.353,
    y: 21.162,
    width: 2.955,
    height: 2.955
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.398,
    y: 26.334,
    width: 2.955,
    height: 2.955
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4.398,
    y: 15.991,
    width: 2.955,
    height: 2.955
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 25.085,
    y: 21.162,
    width: 2.955,
    height: 2.955
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 13.263,
    y: 21.162,
    width: 2.955,
    height: 2.955
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 22.129,
    y: 15.991,
    width: 2.955,
    height: 2.955
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 28.04,
    y: 15.991,
    width: 2.955,
    height: 2.955
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 28.04,
    y: 26.334,
    width: 2.955,
    height: 2.955
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 19.174,
    y: 21.162,
    width: 2.955,
    height: 2.955
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 16.219,
    y: 15.991,
    width: 2.955,
    height: 2.955
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.974,27.874h-1.518c-4.426,0-8.026-3.601-8.026-8.027v-11.821c0-4.426,3.601-8.027,8.026-8.027h1.518c4.425,0,8.026,3.601,8.026,8.027v11.821c0,4.426-3.601,8.027-8.026,8.027ZM38.456,1.493c-3.602,0-6.533,2.931-6.533,6.533v11.821c0,3.602,2.931,6.533,6.533,6.533h1.518c3.602,0,6.532-2.931,6.532-6.533v-11.821c0-3.602-2.931-6.533-6.532-6.533h-1.518Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.957,26.49v6.589c0,.392-.319.71-.711.71H2.204c-.392,0-.711-.318-.711-.71V13.096h28.937v-1.493H0v21.476c0,1.214.989,2.203,2.204,2.203h31.042c1.215,0,2.204-.989,2.204-2.203v-5.794c-.527-.214-1.029-.478-1.493-.794Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardMouse);
export default __webpack_public_path__ + "static/media/keyboard-mouse.2620dad47770775fb489c2357bd85b6f.svg";
export { ForwardRef as ReactComponent };